// extracted by mini-css-extract-plugin
export default {"wait-withdrawal-template":"styles_wait-withdrawal-template__4UIrd"};